<app-menu></app-menu>

<div class="fundo-terms uk-light">
    <div class="uk-container uk-text-center">
        <h1 class="hero-standard-title">Termos e Condições</h1>
        <p class="uk-text-large" style="opacity: 0.9;">Regras e diretrizes para o uso dos nossos serviços.</p>
    </div>
</div>

<div class="uk-container uk-margin-large-top uk-margin-large-bottom">
<p>Bem-vindo à Fluxo-Digital! Estes Termos e Condições regulam o uso dos nossos serviços e a relação entre você (usuário/cliente) e a Fluxo-Digital. Ao contratar ou utilizar qualquer serviço da Fluxo-Digital, você concorda com os termos abaixo.</p>

<h2>1. Definições.</h2>
<ul>
    <li><strong>Fluxo-Digital:</strong> Unidade de negócios da FLUXODIGITAL que oferece serviços de hospedagem web, cloud computing e VPN.</li>
    <li><strong>Usuário/Cliente:</strong> Pessoa física ou jurídica que utiliza nossos serviços.</li>
    <li><strong>Serviços:</strong> Incluem hospedagem web, registro de domínios, servidores virtuais (VPS), banco de dados como serviço (DBaaS) e VPN NoAdsVPN.</li>
    <li><strong>Conta:</strong> Cadastro do usuário na plataforma da Fluxo-Digital, necessário para gerenciar serviços e pagamentos.</li>
</ul>

<h2>2. Uso dos Serviços</h2>
<h3>2.1. Elegibilidade</h3>
<p>O cliente deve ter pelo menos 18 anos ou estar autorizado por um responsável legal para utilizar os serviços.</p>
<p>Empresas devem fornecer informações verídicas e válidas para cadastro.</p>

<h3>2.2. Responsabilidades do Usuário</h3>
<ul>
    <li>Garantir que o uso dos serviços está em conformidade com leis locais e internacionais.</li>
    <li>Não utilizar os serviços para atividades ilegais, incluindo fraude, phishing, spam, armazenamento de conteúdo ilegal ou ataques cibernéticos.</li>
    <li>Manter as credenciais de acesso seguras. O usuário é responsável por qualquer atividade em sua conta.</li>
</ul>

<h3>2.3. Suspensão e Cancelamento</h3>
<p>A Fluxo-Digital reserva-se o direito de suspender ou encerrar seus serviços em cumprimento a ordens judiciais emitidas por autoridades angolanas ou internacionais, desde que Angola esteja sujeita a tais determinações por meio de tratados e acordos ratificados pelo Estado angolano.</p>

<h2>3. Pagamentos e Reembolsos</h2>
<h3>3.1. Planos e Cobranças</h3>
<p>Os serviços da Fluxo-Digital funcionam com pagamento antecipado e renovação conforme o plano contratado (mensal, trimestral, anual).</p>
<p>Os preços podem ser ajustados, sendo que o cliente será notificado com antecedência.</p>

<h3>3.2. Reembolsos</h3>
<p>Não oferecemos reembolso para hospedagem web, VPS, serviços de registro de domínios e VPN após a ativação.</p>

<h2>4. Disponibilidade e Garantia de Serviço</h2>
<h3>4.1. Níveis de Serviço (SLA)</h3>
<p>A Fluxo-Digital se compromete com 99,9% de uptime em seus serviços, salvo casos de manutenção programada ou eventos imprevistos.</p>
<p>Se houver tempo de inatividade superior ao garantido, o cliente pode solicitar créditos proporcionais ao período afetado.</p>

<h3>4.2. Limitações de Responsabilidade</h3>
<p>A Fluxo-Digital não é responsável por perdas de dados causadas por falhas do cliente, ataques cibernéticos ou fatores externos à sua infraestrutura.</p>
<p>Não garantimos compatibilidade dos serviços com softwares específicos não suportados pela nossa plataforma.</p>

<h2>5. Privacidade e Proteção de Dados</h2>
<p>O uso dos serviços está sujeito à Política de Privacidade da Fluxo-Digital.</p>
<p>Dados pessoais são coletados e processados de acordo com a legislação de proteção de dados aplicável.</p>

<h2>6. Uso Aceitável e Proibições</h2>
<p>Os serviços da Fluxo-Digital <strong>NÃO</strong> podem ser usados para:</p>
<ul>
    <li>Hospedagem de conteúdos ilegais, como pornografia infantil, discurso de ódio ou violação de direitos autorais.</li>
    <li>Envio de spam ou e-mails não solicitados.</li>
    <li>Distribuição de malware, vírus ou ataques DDoS.</li>
    <li>Mineração de criptomoedas sem autorização prévia.</li>
</ul>
<p>A violação dessas regras pode resultar em suspensão imediata da conta e denúncia às autoridades competentes.</p>

<h2>7. Modificações nos Termos</h2>
<p>A Fluxo-Digital pode atualizar estes Termos e Condições periodicamente. Qualquer alteração será comunicada por e-mail ou publicada no site. O uso contínuo dos serviços após a alteração significa aceitação dos novos termos.</p>

<h2>8. contacto e Suporte</h2>
<p>Para dúvidas ou suporte, entre em contacto:</p>
<p><strong>E-mail: </strong> <a href="mailto:suporte@fluxo-digital.ao">suporte&#64;fluxo-digital.com</a></p>
<p><strong>Site: </strong> <a href="https://fluxo-digital.com" target="_blank">fluxo-digital.com</a></p>

<p>Ao contratar e utilizar os serviços da Fluxo-Digital, você declara ter lido e concordado com estes Termos e Condições.</p>
</div>
<app-rodape></app-rodape>

